import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableCell, TableRow } from '@material-ui/core'

import { useTableStyles } from '../hooks/tableStylesHook'

import { formatPrice } from '../common/numberUtils'

import { OrderCommissionModel } from '../server/mpsklad_core/Models/OrderCommissionModel'

export const CommissionsRow =
  observer(
    ({commission}: {commission: OrderCommissionModel}) => {
      const classes = useStyles()
      const tableClasses = useTableStyles()

      return (
        <TableRow>
          <TableCell className="table-border">
            <span className={classes.text}>{commission.name}</span>
          </TableCell>

          <TableCell className={clsx('table-border', tableClasses.noWrapCell)}>
            <span className={classes.text}>{formatPrice(commission.amount)}</span>
          </TableCell>

          <TableCell className="table-border">
            <span className={classes.text}>{commission.typeName}</span>
          </TableCell>
        </TableRow>
      )
    })

const useStyles = makeStyles(() => ({
  text: {
    fontSize: 12
  },
  iconButton: {
    marginLeft: 5,
    opacity: 0,
    'td:hover &': {
      opacity: 1
    }
  }
}))